import { useState } from 'react';
import { TeamMember } from '../../lib/types';

interface AddMemberFormProps {
  onSubmit: (member: Partial<TeamMember>, file: File) => Promise<void>;
}

export function AddMemberForm({ onSubmit }: AddMemberFormProps) {
  const [newMember, setNewMember] = useState({
    name: '',
    title: '',
    description: '',
    specialties: '',
    achievements: '',
  });
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedFile) return;

    await onSubmit(
      {
        ...newMember,
        specialties: newMember.specialties.split(',').map(s => s.trim()),
        achievements: newMember.achievements.split('\n').filter(a => a.trim()),
      },
      selectedFile
    );

    setNewMember({
      name: '',
      title: '',
      description: '',
      specialties: '',
      achievements: '',
    });
    setSelectedFile(null);
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-8">
      <h2 className="text-xl font-semibold mb-4">Add New Team Member</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Name</label>
          <input
            type="text"
            value={newMember.name}
            onChange={(e) => setNewMember({ ...newMember, name: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-orange-500 focus:ring-orange-500"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Title</label>
          <input
            type="text"
            value={newMember.title}
            onChange={(e) => setNewMember({ ...newMember, title: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-orange-500 focus:ring-orange-500"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Description</label>
          <textarea
            value={newMember.description}
            onChange={(e) => setNewMember({ ...newMember, description: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-orange-500 focus:ring-orange-500"
            rows={3}
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Specialties (comma-separated)</label>
          <input
            type="text"
            value={newMember.specialties}
            onChange={(e) => setNewMember({ ...newMember, specialties: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-orange-500 focus:ring-orange-500"
            placeholder="Downhill, Enduro, Trail Building"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Achievements (one per line)</label>
          <textarea
            value={newMember.achievements}
            onChange={(e) => setNewMember({ ...newMember, achievements: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-orange-500 focus:ring-orange-500"
            rows={3}
            placeholder="Campion Național 2023&#10;Locul 2 Cupa Europei 2022"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Profile Image</label>
          <input
            type="file"
            onChange={(e) => setSelectedFile(e.target.files?.[0] || null)}
            className="mt-1 block w-full"
            accept="image/*"
            required
          />
        </div>

        <button
          type="submit"
          className="bg-orange-500 text-white px-4 py-2 rounded-md hover:bg-orange-600 transition-colors"
        >
          Add Team Member
        </button>
      </form>
    </div>
  );
}